// Avis Google reproduits mot pour mot (prénom uniquement), dans leur langue d'origine
export const GOOGLE_REVIEWS = [
  {
    name: 'Virginie',
    text: "Un immense merci pour cette étude de numérologie ! Ce fut un moment unique qui m'a éclairée, rassurée et redonnée confiance. Un vrai guide pour mieux se comprendre et avancer sereinement. Une expérience bénéfique que je conseille à tous !"
  },
  {
    name: 'Christophe',
    text: "Le travail de Stephanie est précis dans la technique, inspiré dans l'intuition et emprunt d'une grande humanité et de désir d'accompagner vers une meilleure compréhension de soi. Un grand merci"
  },
  {
    name: 'Marianne',
    text: "Merci encore pour ton accompagnement si précieux, Stéphanie. Tes mots et ton écoute m'ont aidée et m'aident encore aujourd'hui à comprendre mon fonctionnement et à m'apaiser. Tu as su éclairer mon chemin avec douceur et compréhension."
  },
  {
    name: 'Jérémy',
    text: "Un immense merci à Stéphanie pour son soutien et son écoute ! Son accompagnement m'a vraiment boosté et aidé à prendre les bonnes décisions pour mon avenir professionnel. Une super rencontre et une vraie professionnelle que je recommande !"
  },
  {
    name: 'Margaux',
    text: "J'ai découvert la numérologie avec Stéphanie et j'ai beaucoup aimé cette expérience. Un nouveau prisme permettant de mieux se comprendre et surtout de s'orienter. Je reviens souvent sur le travail de nos séances, qui continue de m'éclairer. Stéphanie est douce, à l'écoute et s'installe dans un véritable désir d'aider et d'accompagner. La numérologie est un excellent complément à la thérapie /au coaching."
  }
];

// Lien à fournir par Stéphanie
export const GOOGLE_REVIEWS_URL = 'https://share.google/aTtkGTnwGgaJ5mDpo';
export const GOOGLE_WRITE_REVIEW_URL = 'https://g.page/r/CYbXjGOhtE5QECE/review';

export const reviewsTranslations = {
  fr: {
    eyebrow: 'Avis Google',
    title: 'Ce que disent mes clients',
    rating: '5,0',
    count: '10 avis Google',
    button: 'Voir ma fiche et mes avis Google',
    share: 'Partager votre expérience',
    prev: 'Avis précédent',
    next: 'Avis suivant'
  },
  es: {
    eyebrow: 'Reseñas de Google',
    title: 'Lo que dicen mis clientes',
    rating: '5,0',
    count: '10 reseñas en Google',
    button: 'Ver mi ficha y mis reseñas en Google',
    share: 'Comparte tu experiencia',
    prev: 'Reseña anterior',
    next: 'Reseña siguiente'
  }
};
